import React from 'react';
import Appearance from '../TextAppearance/TextAppearance';
import Conditions from '../ConditionGroup/PropertyConditions';

export default ({ activeTab, scaleText, fonts, uploadFont }) => {
  return (
    <>
      {activeTab === 1 && (
        <Appearance scaleText={scaleText} fonts={fonts} uploadFont={uploadFont} />
      )}
      {activeTab === 3 && <Conditions />}
    </>
  );
};
